/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { Tooltip } from 'reactstrap';
import styled from "styled-components";
import { v4 as uuid } from 'uuid';

/**
 * Taken from reactstrap examples and modded a bit
 * TODO: Make it our own
 */


const StyledDefaultTooltip = styled.span`
  background: ${({ theme }) => theme.ThemeColors.DARK.hex};
  color: white;
  padding: 0.1rem 0.5rem;
  border-radius: 0.25rem;
`;

// Bindings
type TooltipWrapperProps = {
  children?: any,
  className?: string,
  placement?: string,
  id: string,
  tooltip: any,
  delay?: Object,
  preventOpen?: boolean,
  autohide?: boolean,
  forceOpen?: boolean,
};

const initialValues = {
  autohide: true,
  placement: 'right',
  delay: {
    show: 100,
    hide: 100
  },
};

class TooltipWrapper extends React.Component {
  props: TooltipWrapperProps;
  static defaultProps = initialValues;

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false
    };
  }

  componentDidMount(){
    if(this.props.forceOpen){
      this.setState({ tooltipOpen: true });
    }
  }

  toggle() {
    // Keep the tooltip open when forceOpen prop is set. (SINT-1556)
    this.setState({
      tooltipOpen: this.props.forceOpen || !this.state.tooltipOpen
    });
  }

  render() {
    return (
      <span className={this.props.className} id={'ttp-' + this.props.id}>
        <Tooltip autohide={this.props.autohide} placement={this.props.placement} delay={this.props.delay} isOpen={this.state.tooltipOpen && !this.props.preventOpen} target={'ttp-' + this.props.id} toggle={this.toggle}>
          {this.props.tooltip}
        </Tooltip>
        {this.props.children}
      </span>
    );
  }
}

export {TooltipWrapper, StyledDefaultTooltip as DefaultTooltip};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/TooltipWrapper.js